import {
  AFFILIATE_GET,
  AFFILIATE_CHECK_NAME,
  AFFILIATE_SEND_INVITE,
  AFFILIATE_GET_PLAID_LINK_TOKEN,
  AFFILIATE_CREATE_BANK_ACCOUNT,
  AFFILIATE_UPDATE_STRIPE_INFO,
  AFFILIATE_VERIFY_BANK_ACCOUNT,
  AFFILIATE_REQUEST,
  AFFILIATE_SUCCESS,
  AFFILIATE_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  affiliate: null,
  referrer: null,
  isLoading: false,
  error: null
}

const getters = {
  getCurrentAffiliate: (state) => state.affiliate,
  getCurrentReferrer: (state) => state.referrer,
  isAffiliateLoading: (state) => state.isLoading,
  getAffiliateError: (state) => state.error
}

const actions = {
  [AFFILIATE_GET]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .get(`/api/v3/referrers/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS, { affiliate: resp.data.results[0] })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_CHECK_NAME]: ({ commit }, referrer) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .get(`/api/v3/referrers/${referrer}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS, { referrer: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_SEND_INVITE]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .post(`/api/v3/referrers/send_invitation/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_GET_PLAID_LINK_TOKEN]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .post(`/api/v3/referrers/plaid_link_token/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_CREATE_BANK_ACCOUNT]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .post(`/api/v3/referrers/bank_account/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_UPDATE_STRIPE_INFO]: ({ commit }, { ssn, dob }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .put(`/api/v3/referrers/stripe_info/`, {
          id_number: ssn,
          dob
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  },
  [AFFILIATE_VERIFY_BANK_ACCOUNT]: ({ commit }, { deposit1, deposit2 }) => {
    return new Promise((resolve, reject) => {
      commit(AFFILIATE_REQUEST)

      axios
        .post(`/api/v3/referrers/verify_bank_account/`, {
          amount_1: deposit1,
          amount_2: deposit2
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AFFILIATE_SUCCESS, { affiliate: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AFFILIATE_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [AFFILIATE_REQUEST]: (state) => {
    state.isLoading = true
  },
  [AFFILIATE_SUCCESS]: (state, { affiliate, referrer } = {}) => {
    state.isLoading = false
    if (affiliate) state.affiliate = affiliate
    if (referrer) state.referrer = referrer
  },
  [AFFILIATE_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err.message
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
